import classNames from "classnames/bind";

import styles from "./DragUploadImage.module.css";
import { DeleteIcon, EyeIcon } from "../Icons/Icons";
import { useEffect, useState } from "react";
import Loading from "../Loading";
const cx = classNames.bind(styles)
function ImageItem({ toggleViewFull, handleDelete, file }) {
    const [loading, setLoading] = useState(true)
    useEffect(() => {
        const timeout = setTimeout(() => {
            setLoading(false)
        }, 500)
        return () => clearTimeout(timeout)
    }, [])
    return (
        <div className={cx('image')}>
            <img src={file?.thumbUrl} className={cx('image_item')} />
            <div className={cx('filter-top')}>
                <div className={cx('footer-image')}>
                    <div className={cx('control')}>
                        <span onClick={() => toggleViewFull(file?.thumbUrl)}>
                            <EyeIcon color={'white'} />
                        </span>
                        <span onClick={() => handleDelete(file)}>
                            <DeleteIcon color={'white'} />
                        </span>
                    </div>
                </div>
            </div>
            {loading && <div className={cx('loading')}><Loading /></div>}
        </div>
    )
}

export default ImageItem;